module.exports = __webpack_public_path__ + "img/item_2.05978f55.png";